<template>
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">E-mail</th>
        <th scope="col" class="text-center border-0">Distribuidores</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in supervisors" :key="index">
        <td class="td-1">{{ row.id }}</td>
        <td class="td-2 link">
          <router-link
            :to="{
              name: 'admin-supervisor-edit',
              params: { id: row.id },
            }"
          >
            {{ row.name }}
          </router-link>
        </td>
        <td class="td-2">{{ row.email }}</td>
        <td class="td-2 text-center">{{ row.resellers_count }}</td>
        <td class="td-2"><supervisor-buttons :supervisor="row" /></td>
      </tr>
      <tr v-if="supervisors.length === 0">
        <td colspan="5" class="no-content">
          Ainda não tem nenhum supervisor cadastrado.
        </td>
      </tr>
    </tbody>
    <supervisor-imports />
  </table>
</template>

<script>
import SupervisorButtons from './SupervisorButtons.vue';
import SupervisorImports from './SupervisorImports.vue';

export default {
  name: 'supervisor-table',
  props: {
    supervisors: {
      type: Array,
    },
  },
  components: { SupervisorButtons, SupervisorImports },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';
.td {
  &-1 {
    max-width: 60px;
  }
  &-2 {
    min-width: 140px;
    max-width: 300px;
  }
}
</style>
